var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIhoten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 1.33337C6.25334 1.33337 4.83334 2.75337 4.83334 4.50004C4.83334 6.21337 6.17334 7.60004 7.92001 7.66004C7.97334 7.65337 8.02668 7.65337 8.06668 7.66004C8.08001 7.66004 8.08668 7.66004 8.10001 7.66004C8.10668 7.66004 8.10668 7.66004 8.11334 7.66004C9.82001 7.60004 11.16 6.21337 11.1667 4.50004C11.1667 2.75337 9.74668 1.33337 8.00001 1.33337Z",
    fill: "#9A9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3867 9.4333C9.52667 8.1933 6.49334 8.1933 4.62 9.4333C3.77334 9.99996 3.30667 10.7666 3.30667 11.5866C3.30667 12.4066 3.77334 13.1666 4.61334 13.7266C5.54667 14.3533 6.77334 14.6666 8 14.6666C9.22667 14.6666 10.4533 14.3533 11.3867 13.7266C12.2267 13.16 12.6933 12.4 12.6933 11.5733C12.6867 10.7533 12.2267 9.9933 11.3867 9.4333Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIhoten);
export default __webpack_public_path__ + "static/media/ihoten.c5e833cb34257fd2045339b4cf605b93.svg";
export { ForwardRef as ReactComponent };